import { fromJS } from 'immutable';
import {
  OLD_SIGNATORIES_KEYS,
  ALMOST_THERE_INFO,
  SWITCH_BUSINESS_INFO,
  OLD_ACCOUNT_DETAILS_INFO,
  SWITCH_DATE_INFO,
  OFIICER_KEY,
  GET_CUSTOMER_KEY
} from '../../utils/constants';
import {
  SAVE_OLD_SIGNATORIES,
  UPDATE_OLD_SIGNATORIES,
  DELETE_OLD_SIGNATORIES,
  SAVE_ALMOST_THERE_FORM,
  SAVE_SWITCH_BUSINESS_FORM,
  SAVE_SWITCH_DATE_FORM,
  SAVE_OLD_ACCOUNT_DETAILS_FORM,
  RESET_CONFIRM_SWITCH_ERROR
} from './actions';
import {
  COMPLETED_SUCCESS,
  SUBMIT_ENTERPRISE_FORM_FAIL,
  SUBMIT_ENTERPRISE_FORM_SUCCESS
} from './service.actions';
import { FETCH_CUSTOMERBYID_SUCCESS } from '../customers';
import { getNationalityInfo, createPrimaryApplicant } from './utils/mapSignatoryDetails';

export const OFFER_API_DATA = 'offerProductData';
export const CUASTOMER_NATIONALITY_INFO = 'customerNationality';
export const SUBMIT_ENTERPRISE_ERROR = 'submit_enterprise_error';
export const initialState = fromJS({
  loading: false
});

const oldSignatoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_OLD_SIGNATORIES:
      return state.set(OLD_SIGNATORIES_KEYS, getOldSignatories(action.data, state));
    case UPDATE_OLD_SIGNATORIES:
      return state.set(
        OLD_SIGNATORIES_KEYS,
        setOldSignatoryByIndex(state, action.data, action.meta.index)
      );
    case DELETE_OLD_SIGNATORIES:
      return state.set(OLD_SIGNATORIES_KEYS, removeOldSignatoryByIndex(state, action.index));
    case SAVE_ALMOST_THERE_FORM:
      return state.set(ALMOST_THERE_INFO, action.data);
    case SAVE_SWITCH_BUSINESS_FORM:
      return state.set(SWITCH_BUSINESS_INFO, action.data);
    case RESET_CONFIRM_SWITCH_ERROR:
      return state.set(SUBMIT_ENTERPRISE_ERROR, '');
    default:
      return processRemainingActions(state, action);
  }
};
const processRemainingActions = (state, action) => {
  switch (action.type) {
    case SAVE_SWITCH_DATE_FORM:
      return state.set(SWITCH_DATE_INFO, action.data);
    case SAVE_OLD_ACCOUNT_DETAILS_FORM:
      return state.set(OLD_ACCOUNT_DETAILS_INFO, action.data);
    case `${OFIICER_KEY}${FETCH_CUSTOMERBYID_SUCCESS}`:
      return state
        .set(CUASTOMER_NATIONALITY_INFO, getNationalityInfo(action.payload))
        .set(
          OLD_SIGNATORIES_KEYS,
          getOldSignatories(createPrimaryApplicant(action.payload), state)
        );
    case COMPLETED_SUCCESS:
      return state.set(ALMOST_THERE_INFO, action.payload.data);
    case SUBMIT_ENTERPRISE_FORM_SUCCESS:
      return state.set(SUBMIT_ENTERPRISE_ERROR, '');
    case SUBMIT_ENTERPRISE_FORM_FAIL:
      return state.set(SUBMIT_ENTERPRISE_ERROR, getCreateCaseErrors(action.meta));
    case `${GET_CUSTOMER_KEY}${FETCH_CUSTOMERBYID_SUCCESS}`:
      return state
        .set(CUASTOMER_NATIONALITY_INFO, getNationalityInfo(action.payload))
        .set(
          OLD_SIGNATORIES_KEYS,
          getOldSignatories(createPrimaryApplicant(action.payload), state)
        );
    default:
      return state;
  }
};

const getOldSignatories = (data, state) => {
  const signatories = state.get(OLD_SIGNATORIES_KEYS) || [];
  signatories.push(data);
  return signatories;
};

const setOldSignatoryByIndex = (state, data, index) => {
  const signatories = state.get(OLD_SIGNATORIES_KEYS);
  signatories[index] = data;
  return signatories;
};

const removeOldSignatoryByIndex = (state, index) => {
  const signatories = state.get(OLD_SIGNATORIES_KEYS);
  signatories.splice(index, 1);
  return signatories;
};

const getCreateCaseErrors = meta => {
  const content = meta.content ? meta.content.toJS().external_content : {};
  return meta.errorCode && content[`switchCode${meta.errorCode}`]
    ? content[`switchCode${meta.errorCode}`]
    : content.switchCodeDefault;
};

export default oldSignatoriesReducer;
